module.exports = __webpack_public_path__ + "img/logo.5ed2606c.png";